import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {PoliticaTipoProducto} from '../_models/politica-tipo-producto';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PoliticaTipoProductoService {
  private rutServicio: string = AppSettings.rutServiciosPOLITICA + "/api/politicasTiposProductosBancarios";

  constructor(
    private httpClient: HttpClient,
    private autServicio: AutenticacionService,
  ) {}

  getByIdPolitica(id: string): Observable<PoliticaTipoProducto[]> {
    return this.httpClient.get<PoliticaTipoProducto[]>(`${this.rutServicio}/politica/${id}`);
  }

  getByCodigoTipoProducto(codigo: string): Observable<PoliticaTipoProducto[]> {
    return this.httpClient.get<PoliticaTipoProducto[]>(`${this.rutServicio}/tiposProducto/${codigo}`);
  }

  bulk(registros: PoliticaTipoProducto[]): Observable<PoliticaTipoProducto[]> {
    registros.forEach((e: PoliticaTipoProducto) => e.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado());
    return this.httpClient.post<PoliticaTipoProducto[]>(`${this.rutServicio}/bulk`, registros);
  }
}
